define('shell',['durandal/system', 'plugins/router', 'plugins/http', 'durandal/app', 'knockout', 'jquery', 'utils'], function (system, router, http, app, ko, $) {
    var viewmodel = function () {
        var self = this;
        self.app = app;
        self.showInterface = ko.observable(true);
        self.router = router;
        self.http = http;
        self.system = system;
        self.headerPartial = ko.observable();
        self.mapListFiltered = ko.computed(function() {
            return self.router.activeInstruction() && self.router.activeInstruction().fragment !== 'editor/list/all';
        });
        

        router.guardRoute = function (instance, instruction) {
            return self.system.defer(function (dfd) {
                self.http.get("/api/auth/current").then(function (user) {
                    if (!user.authenticated && !(instruction.queryParams && instruction.queryParams.authbypasskey)) {
                        window.location.href = '/?returnUrl=/' + instruction.fragment;
                    }

                    dfd.resolveWith(self, [true]);
                });
            }).promise();
        };

        app.showError = function (response, type, error) {
            //Deal with various kinds of errors from here
            if (error.stack) {
                app.showMessage(error.stack, 'JavaScript Error');
            } else if (error === 'Internal Server Error') {
                app.showMessage(response.responseText, 'Server Error');
            } else {
                app.showMessage('Type: ' + type + ', Error: ' + error + ', response: ' + response.responseText, 'Unexpected Error');
            }
        };

        app.updateLayoutView = function (isEditor) {
            // the editor page needs a slightly different layout (no footer, different header)
            // in SPA-land, the DOM and model bindings don't get regularly flushed from navigation
            // so have to swap / hide individual partial UI elements
            if (isEditor) {
                $('html').addClass('editor');
                self.headerPartial('layouts/_editor-header.html');
            } else {
                $('html').removeClass('editor');
                self.headerPartial('layouts/_default-header.html');
            }
        };

        self.activate = function () {
            router.map([
                { route: ['', 'editor*path'], title: 'Map Editor', moduleId: 'editor/index', isVisible: true },
                { route: ['admin*path'], title: 'Administration Pages', moduleId: 'admin/index', isVisible: false }
            ])
            .buildNavigationModel()
            .mapUnknownRoutes(function (instruction) {
                instruction.config.moduleId = 'static/not-found';
            })
            .activate({ pushState: true });

            router.on('router:route:activating', function (instance, instruction) {
                if (instruction.queryParams && instruction.queryParams.clean) {
                    self.showInterface(false);
                }
            });

            self.addCompanyCss(app.currentUser.companyId);
        };

        self.addCompanyCss = function (companyid) {
            var link = document.createElement("link");
            link.href = "/content/css/" + companyid + ".css";
            link.type = "text/css";
            link.rel = "stylesheet";

            document.getElementsByTagName("head")[0].appendChild(link);
        }
    };

    return viewmodel;
});

